<template>
    <div class="select-list">
        <span v-if="title" class="title">{{title}}</span>
        <el-select
            v-model="newValue"
            :class="`title${title.length}`"
            size="small"
            placeholder="请选择"
            @change="changeSelected"
        >
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    export default {
        name: "SelectList",
        props: {
            title: String,
            form: [Array, Object],
            value: [Number, String]
        },
        computed: {
            options(){
                let arr = []
                for(let item in this.form){
                    arr.push({value: item, label: this.form[item].text})
                }
                return arr
            },
        },
        watch: {
            value: {
                handler(vl){
                    this.newValue = vl
                },
                deep: true
            }
        },
        data(){
            return {
                newValue: this.value
            }
        },
        methods: {
            changeSelected(){
                this.$emit('onBtns', {value: this.newValue, oneWay:true})
            }
        }
    }
</script>

<style lang="scss" scoped>
.select-list{
    position: relative;

    .title{
        position: absolute;
        left: 12px;
        top: 17px;
        font-size: 14px;
        font-weight: 400;
        color: #A8AAAD;
        line-height: 14px;
        z-index: 10;

        &:before{
            content: '';
            position: absolute;
            right: -12px;
            top: 0;
            width: 1px;
            height: 16px;
            background: #E0E1E4;
        }
    }

    .title1 /deep/ input{
        padding-left: 46px;
    }
    .title2 /deep/ input{
        padding-left: 62px;
    }
    .title3 /deep/ input{
        padding-left: 74px;
    }
    .title4 /deep/ input{
        padding-left: 88px;
    }
    .title5 /deep/ input{
        padding-left: 101px;
    }
    .title6 /deep/ input{
        padding-left: 115px;
    }
}
</style>
